<template>
  <div class="login-page">
    <div class="login-content">
      <!-- <div class="left">
        <img class="logo" src="../../assets/bai.png" />
        <img class="leftlogo" src="../../assets/leftIcon.png" />
      </div> -->
      <div class="right">
        <div class="form-title">
          <div class="tit-logo">
            <div class="tit">{{ sysMemberName }}</div>
            <div class="eng">EBA Member Management System</div>
          </div>
          <div class="form-container">
            <a-form-model
              :hideRequiredMark="true"
              ref="loginForm"
              :rules="formRules"
              :model="formValues"
            >
              <a-form-model-item :colon="false" prop="userName">
                <a-input
                  v-model="formValues.userName"
                  placeholder="请输入用户名"
                  size="large"
                  v-on:keyup="formOnEnter"
                >
                  <!-- <img slot="prefix" src="../../assets/loginuser.png" /> -->
                </a-input>
              </a-form-model-item>
              <a-form-model-item :colon="false" prop="memberPwd">
                <a-input-password
                  v-model="formValues.memberPwd"
                  placeholder="请输入密码"
                  size="large"
                  v-on:keyup="formOnEnter"
                >
                  <!-- <img slot="prefix" src="../../assets/pass.png" /> -->
                </a-input-password>
              </a-form-model-item>
              <a-form-model-item>
                <a-button @click="onSubmit" size="large">登录</a-button>
              </a-form-model-item>
            </a-form-model>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import eventStatusMixin from "../../mixins/eventStatus";
import { setToken } from "../../utils/tokenManager";
//import { login } from "./service";
import axios from "axios";

export default {
  name: "Login",
  mixins: [eventStatusMixin],
  data() {
    return {
      formValues: {
        userName: "",
        memberPwd: "",
      },
      sysMemberName: "",
    };
  },
  computed: {
    formRules() {
      return {
        userName: [
          { required: true, message: "请输入用户名", trigger: "blur" },
        ],
        memberPwd: [{ required: true, message: "请输入密码", trigger: "blur" }],
      };
    },
  },
  mounted() {
    this.sysMemberName = window.sysMemberName;
  },
  methods: {
    formOnEnter(e) {
      if (e.keyCode === 13) return this.onSubmit();
    },
    onSubmit() {
      if (this.hasEventState("onSubmit")) return;
      this.addEventState("onSubmit");
      this.$refs.loginForm.validate((valid) => {
        if (valid) {
          const params = { ...this.formValues };
          let url = `${window.ebaHttpRequest}/v2/member/login`;
          axios
            .post(url, { ...params })
            .then((res) => {
              console.log(result);
              let result = res.data;
              if (result.bizCode === 1) {
                setToken(result.data.token);
                this.$router.replace("/app");
              } else this.$message.warning(result.bizRemind, 4);
            })
            .finally(() => {
              this.removeEventState("onSubmit");
            });
          // login
          //   .request(params)
          //   .then((result) => {
          //     if (result.bizCode === 1) {
          //       setToken(result.data.token);
          //       this.$router.replace("/app");
          //     } else this.$message.warning(result.bizRemind, 4);
          //   })
          //   .finally(() => {
          //     this.removeEventState("onSubmit");
          //   });
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../theme.less";
@import "../../utils/convertPxToDesighViewport/convertPxToDesighViewport.less";

.login-page {
  left: 0px;
  top: 0px;
  width: 100vw;
  height: 100vh;
  background: #001930;
  background-image: url("../../assets/bg.png");
  background-size: 100% 100%;
  .login-content {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: row;
    .left {
      width: 60%;
      height: 100%;
      position: relative;
      display: flex;
      flex-direction: column;
      .logo {
        position: absolute;
        top: .convertPxToDesighVH(55) [];
        left: .convertPxToDesighVW(40) [];
        width: .convertPxToDesighVW(160) [];
        height: .convertPxToDesighVH(35) [];
      }
      .leftlogo {
        position: absolute;
        left: 40px;
        top: 30%;
        width: 712px;
        height: 518px;
      }
    }
    .right {
      position: absolute;
      top: 20%;
      left: 63%;
      .form-title {
        width: .convertPxToDesighVW(520) [];
        //height: .convertPxToDesighVH(600)[];
        background: #ffffff;
        border-radius: .convertPxToDesighVH(9) [];
        padding: (60/1080) * 100vh (60/1920) * 100vw .convertPxToDesighVH(20) []
          (60/1920) * 100vw;
        > .tit-logo {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          > .tit {
            font-size: (40/1080) * 100vh;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #0a676d;
          }
          > .eng {
            margin-top: (15/1080) * 100vh;
            font-size: (14/1080) * 100vh;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #cfcfcf;
          }
        }
        > .form-container {
          margin-top: (80/1080) * 100vh;
          ::v-deep .ant-form {
            > .ant-row {
              > .ant-col {
                > .ant-form-item-control {
                  > .ant-form-item-children {
                    > .ant-input {
                      background: @formitem-input-bg;
                      border: @formitem-input-br;
                      border-radius: @formitem-input-bordet-radius;
                      color: #333333;
                    }
                    > .ant-input-affix-wrapper {
                      > .ant-input-lg {
                        background: @formitem-input-bg;
                        border: @formitem-input-br;
                        border-radius: @formitem-input-bordet-radius;
                        color: #333333;
                      }
                    }

                    > .ant-btn {
                      width: 100%;
                      margin-top: .convertPxToDesighVH(70) [];
                      background: linear-gradient(
                        136deg,
                        #3abac4 0%,
                        #57b97c 100%
                      );
                      border-radius: .convertPxToDesighVH(40) [];
                      font-size: (24/1080) * 100vh;
                      font-family: Microsoft YaHei;
                      font-weight: 400;
                      color: #ffffff;
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
// /deep/input {
//   border: 0px;
//   border-radius: 0px;
//   border-bottom: 1px solid #cecece;
// }
</style>
